// extracted by mini-css-extract-plugin
module.exports = {"custom-alert":"style_custom-alert__3JZOE","icon":"style_icon__ja_l-","success":"style_success__2RonI","error":"style_error__15WYf"};